import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { AcronymSection, AcronymList, AcronymItem, AcronymLetter, AcronymText } from './ThankYouStyles';
import { DescriptionSection, DescriptionText, EnergyParticles, EnergyParticle, EnergyCircle, HighlightedWord } from './ThankYouStyles';
import { PhoneButton, ButtonText } from './HeroSectionStyles';
import { FaPhone } from 'react-icons/fa';
import ChannelsComponentUS from './ChannelsSectionUS';
import ProcessFlowSectionUS from './ProcessFlowSectionUS';
import PlatformVideoSectionUS from './PlatformVideoSectionUS';

// Styled container for information sections
const InfoSectionsContainer = styled.div`
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
  margin-top: 4rem;
  padding-top: 2rem;
  
  &.visible {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Container for phone button at page bottom
const BottomPhoneButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 4rem auto 2rem;
  width: 100%;
  text-align: center;
  
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

// Centered button text
const AdjustedButtonText = styled(ButtonText)`
  position: relative;
  left: 0;
  text-align: center;
  margin: 1rem auto 0;
`;

const InfoSectionsUS = ({ isVisible, setRef, onOpenModal }) => {
  // Check if we're on /ty-us route
  const location = useLocation();
  const isThankYouPage = location.pathname === '/ty-us';

  // BIANCA acronym data in English
  const acronymData = [
    { letter: 'B', text: 'Artificial Intelligence' },
    { letter: 'I', text: 'bot for' },
    { letter: 'A', text: 'scheduling' },
    { letter: 'N', text: 'and' },
    { letter: 'C', text: 'lead' },
    { letter: 'A', text: 'nurturing' }
  ];

  // Generate random energy particles
  const renderEnergyParticles = () => {
    const particles = [];
    const colors = ['#00FFFF', '#64B6FF', '#0080FF', '#FFFFFF'];
    const sizes = ['4px', '6px', '8px', '10px'];
    
    for (let i = 0; i < 20; i++) {
      const top = `${Math.random() * 100}%`;
      const left = `${Math.random() * 100}%`;
      const color = colors[Math.floor(Math.random() * colors.length)];
      const size = sizes[Math.floor(Math.random() * sizes.length)];
      const duration = `${2 + Math.random() * 3}s`;
      const delay = `${Math.random() * 2}s`;
      
      particles.push(
        <EnergyParticle 
          key={i}
          top={top}
          left={left}
          color={color}
          size={size}
          duration={duration}
          delay={delay}
        />
      );
    }
    
    return particles;
  };

  return (
    <InfoSectionsContainer className={isVisible ? 'visible' : ''} ref={setRef}>
      {/* BIANCA acronym explanation section */}
      <AcronymSection isVisible={isVisible}>
        <AcronymList>
          {acronymData.map((item, index) => (
            <AcronymItem key={index} index={index} isVisible={isVisible}>
              <AcronymLetter isVisible={isVisible}>{item.letter}</AcronymLetter>
              <AcronymText index={index} isVisible={isVisible}>{item.text}</AcronymText>
            </AcronymItem>
          ))}
        </AcronymList>
      </AcronymSection>
      
      {/* BIANCA description section */}
      <DescriptionSection>
        <EnergyParticles>
          {renderEnergyParticles()}
        </EnergyParticles>
        <EnergyCircle />
        <DescriptionText>
          BIANCA is an AI agent specialized in <HighlightedWord>maximizing</HighlightedWord> the conversion of <HighlightedWord>leads</HighlightedWord> into <HighlightedWord>appointments</HighlightedWord>
        </DescriptionText>
      </DescriptionSection>
      
      {/* Support channels section */}
      <ChannelsComponentUS />
      
      {/* Process flow section */}
      <ProcessFlowSectionUS onOpenModal={onOpenModal} />
      
      {/* Platform video section */}
      <PlatformVideoSectionUS />
    </InfoSectionsContainer>
  );
};

export default InfoSectionsUS;
